import React from 'react';

import { Icon } from '../icons';

export const WarningMiniIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M20,25.6 C20,27.8056 18.2056,29.6 16,29.6 C13.7944,29.6 12,27.8056 12,25.6 C12,23.3944 13.7944,21.6 16,21.6 C18.2056,21.6 20,23.3944 20,25.6 Z M12.463,5.10245625 L13.143,17.0024563 C13.17495,17.561275 13.70205,18 14.3415,18 L17.6585,18 C18.29795,18 18.82505,17.561275 18.857,17.0024563 L19.537,5.10245625 C19.57125,4.5026875 19.0248,4 18.3385,4 L13.6615,4 C12.9752,4 12.42875,4.5026875 12.463,5.10245625 Z" />
    </svg>
  );
};
